import { z } from 'zod/v4';

export const smsStatusOptions = [
  'Pending',
  'Sent',
  'Permanent Fail',
  'Temporary Fail',
] as const;

export const smsStatusSchema = z.enum(smsStatusOptions);

export type SmsStatus = z.infer<typeof smsStatusSchema>;
